import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useMe } from "@/components/Layout";
import { useApi, errMsg } from "@/lib/api";
import { ROLE_LABELS } from "@/lib/constants";

export default function UsersPage() {
  const me = useMe();
  const api = useApi();
  const [d, setD] = useState(null);
  const load = () => api.get("/users").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { if (me.role === "admin") load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (me.role !== "admin") return <Navigate to="/" replace />;
  const setRole = async (u, role) => {
    try { await api.patch(`/users/${u.user_id}/role`, { role }); toast.success("Ruolo aggiornato"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6 rise max-w-4xl" data-testid="users-page">
      <div>
        <p className="micro-label">Accessi</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">Utenti</h1>
        <p className="text-slate-400 mt-2 text-sm">I collaboratori si registrano dalla pagina di accesso e compaiono qui "in attesa". Abilitali come Collaboratore per dar loro accesso a preventivi, catalogo e clienti.</p>
      </div>
      <div className="bg-slate-900 border border-slate-800 rounded-lg divide-y divide-slate-800">
        {(d?.users || []).map((u) => (
          <div key={u.user_id} className="flex flex-col sm:flex-row sm:items-center gap-3 p-4" data-testid={`user-row-${u.user_id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{u.name || u.email}</div>
              <div className="text-xs text-slate-400 truncate">{u.email}{u.user_id === me.user_id && " · tu"}</div>
            </div>
            <Select value={u.role} onValueChange={(v) => setRole(u, v)}>
              <SelectTrigger className={`sm:w-64 ${u.role === "in_attesa" ? "border-amber-500/60 text-amber-300" : ""}`} data-testid={`user-role-select-${u.user_id}`}><SelectValue /></SelectTrigger>
              <SelectContent>{d.roles.map((r) => <SelectItem key={r} value={r}>{ROLE_LABELS[r] || r}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
}
